import { render } from "./PageHeader.vue?vue&type=template&id=4d35ddb7&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=4d35ddb7&lang=scss&scoped=true"

import exportComponent from "D:\\projectAll\\cnb_2\\oulimojuxiaozhunxitong\\BOSS_GC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d35ddb7"]])

export default __exports__